import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { SecurityConstants } from '../constants/security-constants';
import { isPlatformBrowser } from '@angular/common';
import { PermissionType } from 'src/app/enums';
import { StringHelper } from 'src/app/helpers';

@Injectable()
export class SecurityHelperService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  get subjectObligedId(): number | null {
    if (isPlatformBrowser(this.platformId)) {
      return parseInt(localStorage.getItem(SecurityConstants.SUBJECT_OBLIGED_ID));
    }
    return null;
  }

  set subjectObligedId(value: number | null) {
    if (isPlatformBrowser(this.platformId)) if (value) localStorage.setItem(SecurityConstants.SUBJECT_OBLIGED_ID, value.toString());
  }

  get token(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(SecurityConstants.TOKEN_KEY);
    }
    return null;
  }

  set token(value: string | null) {
    if (isPlatformBrowser(this.platformId)){
      if (value){
        localStorage.setItem(SecurityConstants.TOKEN_KEY, value);
        localStorage.setItem(SecurityConstants.LOGIN_KEY, new Date().toString());
      }
    }
  }

  get showConfirmationEmailAlert(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      let localStorageValue = localStorage.getItem(SecurityConstants.SHOW_CONFIRMED_EMAIL_ALERT);

      if (localStorageValue) return JSON.parse(localStorageValue);
      return true;
    }
    return false;
  }

  set showCurrentSystemAlert(value: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(SecurityConstants.SHOW_CURRENT_SYSTEM_ALERT, JSON.stringify(value));
    }
  }

  get showCurrentSystemAlert(): any {
    if (isPlatformBrowser(this.platformId)) {
      let localStorageValue = localStorage.getItem(SecurityConstants.SHOW_CURRENT_SYSTEM_ALERT);
      if (localStorageValue) return JSON.parse(localStorageValue);
      return true;
    }
    return false;
  }

  set showConfirmationEmailAlert(value: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(SecurityConstants.SHOW_CONFIRMED_EMAIL_ALERT, JSON.parse(value.toString()));
    }
  }

  get rememberMe(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      let localStorageValue = localStorage.getItem(SecurityConstants.REMEMBER_ME_KEY);

      if (localStorageValue) return JSON.parse(localStorageValue);
      return false;
    }
    return false;
  }

  set rememberMe(value: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(SecurityConstants.REMEMBER_ME_KEY, JSON.parse(value.toString()));
    }
  }

  get permissions(): PermissionType[] {
    if (isPlatformBrowser(this.platformId)) {
      let localStorageValue = localStorage.getItem(SecurityConstants.PERMISSIONS_KEY);
      if(StringHelper.isNullOrEmpty(localStorageValue)) {
        return [];
      }

      return localStorageValue.split(',').map(x => Number.parseInt(x));
    }
    else {
      return [];
    }
  }

  set permissions(value: PermissionType[]) {
    if (isPlatformBrowser(this.platformId)) {

      localStorage.setItem(SecurityConstants.PERMISSIONS_KEY, value.join(','));
    }
  }


  isSalesAdmin(): boolean {
    if(isPlatformBrowser(this.platformId)){
      return this.permissions.some(p => p === PermissionType.SalesAdmin);
    }

    return false;
  }


  clearAuthenticationValues(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(SecurityConstants.TOKEN_KEY);
    }
  }
}
